import { useNavigation } from 'react-router';

/**
 * Returns whether navigation is happening, both when navigating to
 * a completely different route, or if loaders are updating to rerender
 * the current route.
 */
export const useIsBusy = (): boolean => {
  const { state } = useNavigation();
  return state !== 'idle';
};
